import disciplinaryCondition from '@/api/disciplinary-condition'
import disciplinarySubType from '@/api/disciplinary-sub-type'
import disciplinaryActivity from '@/api/disciplinary-activity'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  disciplinarySubTypes: [],
  disciplinaryActivities: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DISCIPLINARY_SUB_TYPES(state, data) {
    state.disciplinarySubTypes = data
  },
  SET_DISCIPLINARY_ACTIVITIES(state, data) {
    state.disciplinaryActivities = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return disciplinaryCondition.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return disciplinaryCondition.store(data)
  },

  async find(context, id) {
    return await disciplinaryCondition.find(id)
  },

  update(context, data) {
    return disciplinaryCondition.update(data)
  },

  delete(context, data) {
    return disciplinaryCondition.destroy(data)
  },
  fetchDisciplinarySubType(context) {
    return disciplinarySubType
      .get({
        params: {
          fields: {
            disciplinary_sub_types:
              'dis_sub_type_id,dis_sub_type_kh,dis_sub_type_en'
          },
          page: -1
        },
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      .then(response => {
        context.commit('SET_DISCIPLINARY_SUB_TYPES', response.data)
      })
      .catch(error => {
        Promise.reject(error.data)
      })
  },
  fetchDisciplinaryActivity(context) {
    return disciplinaryActivity
      .get({
        params: {
          fields: {
            disciplinary_activities:
              'dis_activity_id,dis_activity_kh,dis_activity_en'
          },
          page: -1
        },
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      .then(response => {
        context.commit('SET_DISCIPLINARY_ACTIVITIES', response.data)
      })
      .catch(error => {
        Promise.reject(error.data)
      })
  }
}
